import * as React from 'react';
const SvgWarningFilled = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <circle cx={8} cy={8} r={8} fill="currentColor" />
        <path
            d="M9.234 2.976l-.28 6.734H7.26l-.266-6.734h2.24zm-1.12 10.122c-.196 0-.383-.037-.56-.112a1.621 1.621 0 01-.448-.294 1.537 1.537 0 01-.308-.434 1.295 1.295 0 01.308-1.484c.13-.13.28-.229.448-.294a1.428 1.428 0 011.106 0c.177.065.327.163.448.294.13.121.233.266.308.434a1.295 1.295 0 010 1.05 1.537 1.537 0 01-.308.434c-.121.121-.27.22-.448.294-.168.075-.35.112-.546.112z"
            fill="#FFF"
        />
    </svg>
);
export default SvgWarningFilled;
